export default "__VITE_ASSET__BPj9hFE0__"